import React, { ChangeEvent, useState } from 'react';
import { Typography } from '@mui/material';
import { styled } from '@mui/system';

import './DateInput.scss';

const StyledDateInput = styled('input')`
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  padding: 0.5rem;
`;

type DateInputProps = {
  onDateChange: (event: ChangeEvent<HTMLInputElement>) => void;
  today: string;
};

const DateInput = ({ onDateChange, today }: DateInputProps) => {
  const [selectedDate, setSelectedDate] = useState(today);

  const handleDateChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSelectedDate(event.target.value);
    onDateChange(event);
  };

  return (
    <div className="date-input-container">
      <Typography variant="h5" color="primary">
        <label className="label" htmlFor="dateInput">
          Select a date:
        </label>
      </Typography>
      <StyledDateInput
        type="date"
        id="dateInput"
        value={selectedDate}
        onChange={handleDateChange}
      />
    </div>
  );
};

export default DateInput;
